import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { allAgenciesShortDataSelector, scopeAgenciesShortDataSelector } from 'src/features/appSettings';
import { AgencyShortData } from 'src/types';
import { useUserRole } from '../useUserRole';

const filterAgencyOnlyFullFeaturesAgencies = (agency: AgencyShortData): boolean => {
  const date = new Date();
  return (agency.fullFeaturesExpiredAt && new Date(agency.fullFeaturesExpiredAt) > date) ?? false;
};

export const useAgencies = () => {
  const { isSupperAdmin } = useUserRole();

  const scopedAgencies = useSelector(
    isSupperAdmin ? allAgenciesShortDataSelector : scopeAgenciesShortDataSelector,
  ).filter(filterAgencyOnlyFullFeaturesAgencies);
  const allAgencies = useSelector(allAgenciesShortDataSelector);

  const scopedAgenciesWithoutPartners = useMemo(() => {
    return scopedAgencies.filter((agency) => !agency.isPartner);
  }, [scopedAgencies]);

  const scopedAgenciesWithoutTransportPartners = useMemo(() => {
    return scopedAgencies.filter((agency) => !agency.isTransportProvider);
  }, [scopedAgencies]);

  const allAgenciesWithoutPartners = useMemo(() => {
    return allAgencies.filter((agency) => !agency.isPartner);
  }, [allAgencies]);

  const allAgenciesWithoutTransportPartners = useMemo(() => {
    return allAgencies.filter((agency) => !agency.isTransportProvider);
  }, [allAgencies]);

  return {
    scopedAgencies,
    scopedAgenciesWithoutPartners,
    allAgencies,
    allAgenciesWithoutPartners,
    allAgenciesWithoutTransportPartners,
    scopedAgenciesWithoutTransportPartners,
  };
};
